
  <div>
    <button [type]="to.type" [ngClass]="'btn btn-' + to.btnType" (click)="onClick($event)">
      {{ to.text }}
      <i class="{{to.icon.fontSet}} {{to.icon.fontIcon}}" *ngIf="to.icon"></i>
    </button>
  </div>
      